import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence, initializeFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'your-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'your-auth-domain',
  projectId: (import.meta.env.DEV ? 'demo-masonic-tools' : import.meta.env.VITE_FIREBASE_PROJECT_ID) || 'masonic-tools-prod',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'your-storage-bucket',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || 'your-sender-id',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || 'your-app-id',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Check if we should use emulators
const isDevelopment = import.meta.env.DEV;
const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true' || isDevelopment;

// Initialize services
export const auth = getAuth(app);
export const db = useEmulators
  ? initializeFirestore(app, {
      experimentalAutoDetectLongPolling: true,
    })
  : getFirestore(app);
export const functions = getFunctions(app, 'europe-west2');
export const storage = getStorage(app);

// Connect to emulators in development mode
if (useEmulators) {
  try {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, '127.0.0.1', 8090);
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
    connectStorageEmulator(storage, '127.0.0.1', 9199);
    
    console.log('🔥 Connected to Firebase Emulators');
  } catch (error) {
    console.error('❌ Could not connect to emulators:', error);
  }
}

// Enable offline persistence (only in production)
if (!isDevelopment && import.meta.env.VITE_USE_EMULATORS !== 'true') {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Firebase persistence: Multiple tabs open');
    } else if (err.code === 'unimplemented') {
      console.warn('Firebase persistence not supported');
    }
  });
}

export default app;

